export default function ({ app }) {
  const language = app.i18n.locale
  const apiKey = app.$config.googleMapsKey
  const script = document.createElement("script")
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&channel=1&loading=async&language=${language}&libraries=places`
  script.async = true
  document.head.appendChild(script)
}
